import { dabFilmsConstants } from "./../actions/constants/dabFilmsConstant";

type DABFilmsDataState = {
	items: any[];
};

const initialDABFilmsData: DABFilmsDataState = {
	items: [],
};

const dabFilmsData = (state = initialDABFilmsData, action: any) => {
	switch (action.type) {
		case dabFilmsConstants.DABFilmsGetByfilterRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case dabFilmsConstants.DABFilmsGetByfilterSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isListSuccess: true,
				items: action.payload
			};
		case dabFilmsConstants.DABFilmsGetByfilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				status: action.payload,
			};

		case dabFilmsConstants.DABFilmsDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case dabFilmsConstants.DABFilmsDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDetailComplete: true,
				dabFilmsInput: action.payload,
			};
		case dabFilmsConstants.DABFilmsDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDetailComplete: true,
				status: action.payload,
			};

		case dabFilmsConstants.DABFilmsDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case dabFilmsConstants.DABFilmsDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		case dabFilmsConstants.DABFilmsDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleteCompleted: true,
				status: action.payload,
			};

		case dabFilmsConstants.DABFilmsVideoStatusUpdateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isUpdateStatus: false,
			};
		case dabFilmsConstants.DABFilmsVideoStatusUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateStatus: true,
				status: action.payload.message,
			};
		case dabFilmsConstants.DABFilmsVideoStatusUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				status: action.payload,
			};

		case dabFilmsConstants.DABFilmsSaveRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
			};
		case dabFilmsConstants.DABFilmsSaveSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				status: action.payload.status,
			};
		case dabFilmsConstants.DABFilmsSaveFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default dabFilmsData;
